import { SheetException } from "../../../../presentation/services/DepartmentUploadExcel/DepartmentUploadExcel.exceptions";

export default class CompanyImportModel {
    constructor({ accountingId, companyId, source, year, serieIds, points }) {
        this.accountingId = accountingId;
        this.companyId = companyId;
        this.source = source;
        this.year = year.toString().replace(/[^\d]+/g, "");
        this.serieIds = serieIds;
        this.points = points;
    }

    validate() {
        if (!this.accountingId)
            throw new SheetException(
                "Id da contabilidade não informado na planilha."
            );

        if (!this.companyId)
            throw new SheetException(
                "Id da empresa não informado na planilha."
            );

        if (!this.source)
            throw new SheetException(
                "Fonte de Dados não informado na planilha."
            );

        if (!this.year)
            throw new SheetException("Ano não informado na planilha.");

        if (!this.points)
            throw new SheetException("Valores não informado na planilha.");
    }
}
